var IMPERSONATE_PATH = "/impersonate";

angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when(IMPERSONATE_PATH, {
        templateUrl: 'assets/impersonate/index.html',
        controller: 'ImpersonateController',
        title: 'layout.HOME',
        sidebar: 'home'
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/impersonate_route.js
// module id = 815
// module chunks = 3